import { useAuth } from "../../utils/AuthContext/AuthContext.jsx";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import CompletedSVG from "../../assets/Completed.jsx";
import SignatureSVG from "../../assets/Signature.jsx";
import config from '../../utils/config.js'; 
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
// Import your action creators
import { saveAmendmentData, setStep } from '../../redux/actions';

const AmendmentPacketComplete = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  
  useEffect(() => {
    const etchPacketEidFromUrl = new URLSearchParams(window.location.search).get('etchPacketEid');
    const formIdFromUrl = new URLSearchParams(window.location.search).get('formId');
    const selectedIndexFromUrl = new URLSearchParams(window.location.search).get('si');
    // const amendmentIdFromUrl = new URLSearchParams(window.location.search).get('amendmentId');
    if (etchPacketEidFromUrl) {
        setEtchPacketEid(etchPacketEidFromUrl);
      }
    if (formIdFromUrl) {
      setFormId(formIdFromUrl);
    }
    if (selectedIndexFromUrl) {
      setSelectedIndex(selectedIndexFromUrl, 10);
    }
  }, []);
    
  const [etchPacketEid, setEtchPacketEid] = useState('');
  // const [packetDetails, setPacketDetails] = useState({});
  const [formId, setFormId] = useState('');
  // const [amendmentId, setAmendmentId] = useState('');
  const { token } = useAuth();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
const navigate = useNavigate();
const dispatch = useDispatch();
const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

// Add formData selector from Redux store
const formData = useSelector(state => state?.amendment?.amendExtend?.contracts?.[selectedIndex]);

const amendmentData = useSelector((state) => {
  if (selectedIndex !== null) { // Ensure selectedIndex is not null before accessing state
    const amendments = state?.amendment?.amendExtend?.contracts?.[selectedIndex]?.amendments;
    return amendments?.[amendments.length - 1]?.amendmentData;
  }
  return null; // Return null or a default value if selectedIndex is not set
});

    // State hooks for form fields (assuming they are part of amendmentData)
const [lastContractDate, setLastContractDate] = useState(amendmentData && amendmentData.contractCompletionDate);
const [buyer1FirstName, setBuyer1FirstName] = useState(amendmentData && amendmentData.buyer1FirstName);
const [buyer1LastName, setBuyer1LastName] = useState(amendmentData && amendmentData.buyer1LastName);
const [buyer2FirstName, setBuyer2FirstName] = useState(amendmentData && amendmentData.buyer2FirstName);
const [buyer2LastName, setBuyer2LastName] = useState(amendmentData && amendmentData.buyer2LastName);
const [seller1Name, setSeller1Name] = useState(amendmentData && amendmentData.seller1Name); 
const [seller2Name, setSeller2Name] = useState(amendmentData && amendmentData.seller2Name); 
const [listingAgentName, setListingAgentName] = useState(amendmentData && amendmentData.listingAgentName); 
const [listingAgentEmail, setListingAgentEmail] = useState(amendmentData && amendmentData.listingAgentEmail); 
const [amendmentId, setAmendmentId] = useState(amendmentData && amendmentData.amendmentId);
const [contractCompletionDate, setContractCompletionDate] = useState(amendmentData && amendmentData.contractCompletionDate);
//   const [amendmentDate, setAmendmentDate] = useState(amendmentData && amendmentData.amendmentDate);
const [amendmentDate, setAmendmentDate] = useState(new Date());
const [expirationDate, setExpirationDate] = useState(amendmentData && amendmentData.expirationDate);  
const [currentDates, setCurrentDates] = useState(amendmentData && amendmentData.currentDates || {});
const [newDates, setNewDates] = useState(amendmentData && amendmentData.newDates || {});
const [otherDatesText, setOtherDatesText] = useState(amendmentData && amendmentData.otherDatesText);
const [otherAmendmentsText, setOtherAmendmentsText] = useState(amendmentData && amendmentData.otherAmendmentsText);
const [sendToSeller, setSendToSeller] = useState(amendmentData && amendmentData.sendToSeller);
const [packetDetails, setPacketDetails] = useState({});
const [propertyDescription, setPropertyDescription] = useState(
  amendmentData?.propertyDescription || 
  formData?.propertyData?.data?.lotInfo?.legalDescription || 
  formData?.data?.propertyDescription
);
const [address, setAddress] = useState(amendmentData && amendmentData.address);
const [county, setCounty] = useState(
  amendmentData?.county ||
  formData?.propertyData?.data?.ownerInfo?.mailAddress?.county ||
  formData?.data?.propertyCounty
);

  // console.log("Form ID:", formId);
  // console.log("Selected Index:", selectedIndex);

  const navigateToHome = () => {
    navigate(`/`);
};
  
  // console.log("Amendment ID:", amendmentId);  
  // console.log("Form ID:", formId);
  // console.log("Packet Detail", packetDetails);

  useEffect(() => {
    if (!etchPacketEid) {
      return;
    }
  
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${config.apiBaseUrl}/amendment/packet/${etchPacketEid}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setPacketDetails(data?.data?.etchPacket);
        // console.log("Data Inside Effect:", data);

        const amendmentToUpdate = amendmentData;
  
        if (!amendmentToUpdate) {
          console.error("No amendment found with the specified ID");
          setIsLoading(false);
          return;
        }

        // After fetching packet details, update the form data with the etchPacketEid
          const putResponse = await fetch(`${config.apiBaseUrl}/formdata/${formId}/amendmentdata/${amendmentId}`, {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
              data: {
                  ...amendmentToUpdate,
                  etchPacketEid: etchPacketEid,
                  packetDetails: data?.data?.etchPacket
              },
              
          }),
        })
  
        if (!putResponse.ok) {
          throw new Error(`HTTP error! status: ${putResponse.status}`);
        }
  
        const putData = await putResponse.json();
        // console.log('Success:', putData);
      } catch (e) {
        setError(e.toString());
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [etchPacketEid, formId, amendmentId, amendmentData]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

      let status, statusClasses, remainingSigners;

      if (packetDetails && packetDetails?.documentGroup) {
        status = packetDetails?.status;
        remainingSigners = packetDetails?.numberRemainingSigners;
    
        if (status === 'completed') {
            statusClasses = "bg-green-100 text-green-600 rounded-xl text-center p-1";
        } else {
            statusClasses = "bg-blue-100 text-blue-700 rounded-xl text-center p-1";
        }
    }

    // console.log("PacketDetails outside of useEffect:", packetDetails);

    if (packetDetails && packetDetails?.documentGroup && packetDetails?.documentGroup?.signers) {
      const lastCompletedRoutingOrder = packetDetails?.documentGroup?.signers.reduce((maxOrder, signer) => {
        return signer.status === 'completed' ? Math.max(maxOrder, signer.routingOrder) : maxOrder;
      }, 0);

      const newSigners = packetDetails?.documentGroup.signers.map((signer, index) => {
        let statusText;
        if (signer.status === 'completed') {
          statusText = 'Signed';
        } else if (signer.routingOrder === lastCompletedRoutingOrder + 1) {
          statusText = 'Awaiting Signature';
        } else {
          statusText = 'Awaiting Email After Signer Above Signs';
        }
        return { ...signer, statusText }; // return the signer object with the statusText
      })
    }
    
  if (packetDetails && packetDetails?.documentGroup) {
      return (          
        <div className="w-[375px] md:w-[750px] flex justify-start items-center max-h-[825px]">
          <div className="w-[375px] md:w-[750px] p-6 mt-3 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] flex-col gap-8 flex">
            <div className="gap-5 p-5">
            {
              packetDetails && packetDetails?.documentGroup && packetDetails?.documentGroup.signers.length > 1 ? (
                <> 
                   <h1 className="text-shi-green font-semibold w-[300px] md:w-[650px] mb-5 h-auto text-lg md:text-3xl">
                    Congratulations {packetDetails?.documentGroup?.signers?.[0]?.name} You have signed!
                  </h1>
                   <span className="text-slate-700 font-light w-[300px] md:w-[650px] font-[Inter] h-auto text-[14px] md:text-lg">
                    <strong className="font-semibold">Next Steps:</strong> An email was sent to {packetDetails?.documentGroup?.signers?.[1]?.name}. After they sign, an email will either be sent automatically to the listing agent, or you'll need to send the contract manually depending on if you chose the "auto send to listing agent" checkbox.
                  </span> 
                </>
              ) : (
                <>
                  <h1 className="text-shi-green font-semibold w-[300px] md:w-[650px] h-auto text-lg md:text-3xl">
                    Congratulations {packetDetails?.documentGroup?.signers?.[0]?.name} You have signed! One Step Closer to Home Ownership
                  </h1>
                  <span className="text-slate-700 font-light w-[300px] md:w-[650px] h-auto font-[Inter] text-[14px] md:text-lg mt-2">
                    <strong className="font-semibold">Next Steps:</strong> If you checked Yes to auto send to the Selling Agent then an email was already sent to the listing agents email for review. Otherwise you'll have to manage this manually. You can check the status of the contract in the dashboard.
                  </span> 
                </>
              ) 
            }
            </div>
          {packetDetails && packetDetails?.documentGroup && (
            <div className="gap-5 p-5">
                <p className="m-2"><strong>Contract Name:</strong> {packetDetails?.name}</p>
                  <p className="m-2">
                  <strong>Status:</strong> <div className={`w-auto p-1 px-2 inline-flex items-center text-sm font-[Inter] justify-center ${statusClasses}`}>{status === "completed" ? "Completed" : "In Progress"}</div>
                  </p>
                <p className="m-2 pb-5"><strong>Number Remaining Signers:</strong> {packetDetails?.numberRemainingSigners}</p>
                {
                  packetDetails && packetDetails?.documentGroup && packetDetails?.documentGroup?.signers && packetDetails?.documentGroup?.signers.map((signer, index) => {
                    return (
                      <div key={index} className="flex-col justify-start m-2 gap-5 w-[375px] md:w-[750px]">
                        <div className="inline-flex justify-start w-[330px] md:w-[750px]">
                          {signer.status === 'completed' && <CompletedSVG/>}
                          {signer.status === 'sent' && <SignatureSVG />}
                          <h1 className="pl-2 pr-2 font-bold">{signer.name}</h1>
                          <span>
                            {signer.statusText} 
                          </span>
                        </div>
                        <div className="inline-flex justify-start w-[330px] md:w-[750px] ml-11">
                          <span className="mb-3 pr-4">#{signer.routingOrder} - Signer</span>
                          <span>{signer.email}</span>
                        </div>
                      </div>
                    );
                  })
                }
                <div className="flex flex-col gap-6 items-center w-full justify-center text-center m-5">
                  {/* {packetDetails?.documentGroup?.files?.[0]?.downloadURL && (
                    <button 
                      className="w-[170px] md:w-[200px] justify-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 items-start flex"
                    >
                      <a href={packetDetails?.documentGroup?.files[0]?.downloadURL}>Download Contract</a>
                    </button>
                  )} */}
                  <button 
                      className="w-[170px] md:w-[200px] justify-center text-center text-shi-green bg-slate-200 text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-400 items-center flex"
                      onClick={navigateToHome}
                      >
                      Return Home</button>
                </div>
            </div>
            )}
          </div>
        </div>
      );
      }; 
    };


export default AmendmentPacketComplete;
    